import * as React from "react";
import type { SVGProps } from "react";
const SvgImageMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m4.903 21.6 10.2-9.6 4.8 4.8m-15 4.8h12a3.6 3.6 0 0 0 3.6-3.6v-6m-15.6 9.6a3.6 3.6 0 0 1-3.6-3.6V6a3.6 3.6 0 0 1 3.6-3.6h7.8M15.909 6h6.788M8.503 7.8a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0"
    />
  </svg>
);
export default SvgImageMinus;
